export { default } from './LightMontlyHistogramContainer';
